<template>
  <div class="modal micromodal-slide" aria-hidden="true" id="modal-2" v-bind:class="{ 'is-open': open }">
    <div class="modal__overlay" v-on:click="close()" tabindex="-1"></div>
    <div class="modal_item modal_cart cart_detail">
      <button v-on:click="close()" class="close">
        <span class="close_image"><img src="../../assets/images/close.png" alt=""></span>
      </button>


      <div class="scroll" ref="modal__content">
        <div v-if="this.cartItems.length != 0" class="cart_btn_wrap">
          <button class="btn_blue" @click="onClickNextPage()">次へ</button>
        </div>
        <div class="cart_wrap">
          <p class="cart_title ab">カートの合計</p>
          <div class="price_wrap">
            <p class="price_sum rm" v-model="this.allBcPrice"><span class="yen ab">￥</span>{{ this.allBcPrice.toLocaleString() }}</p>
            <p class="cart_point rm" v-model="this.allBcPoint"><span class="point ab">ポイント：</span>{{ this.allBcPoint.toLocaleString() }}<span class="cart_pt ab">pt</span></p>
          </div>
        </div>
        <div class="cart_tab">
          <input type="radio" id="tab1" name="tab" value="1" v-model="cartTab">
          <label for="tab1" class="tab" v-bind:class="{'isActive': this.cartTab === '1'}"><span class="ab">BC</span>：<span class="rb">{{ purchaseCartBC }}</span></label>
          <input type="radio" id="tab2" name="tab" value="2" v-model="cartTab">
          <label for="tab2" class="tab" v-bind:class="{'isActive': this.cartTab === '2'}"><span class="ab">BC</span>：<span class="rb">その他</span></label>
        </div>
        <div class="tab_contents">
          <div class="bc_user" v-if="this.cartTab === '1'">

            <div class="" v-if="this.cartItems.length != 0">
              <div class="select_item" v-for="(cartItem, n) in cartItems" :key="n" v-model="cartItems">
                <div class="image_wrap">
                  <div class="select_image">
                    <!-- <img :src="cartItem.item.image" alt="" v-on:error="imageError"> -->
                    <img :src="cartItem.item.image" v-on:error="imageError" :data-noimage="cartItem.item.noImage" alt="">
                  </div>
                  <p class="select_item--title ab">{{ cartItem.item.title }}</p>
                  <button class="delete btn_delete btn_mini" v-on:click="deleteItem(n)">削除</button>
                </div>
                <div class="select_contents">
                  <div class="manth_wrap">
                    <div class="month_item" :class="{no_month: cartItem.countItem[0].month == 0}">
                      <p class="month before_border ab" v-if="cartItem.countItem[0].month != 0"><span class="month_number rb">{{ cartItem.countItem[0].month }}</span>月</p>
                      <p class="month" style="border-bottom: none;" v-else></p>
                      <div class="count_wrap">
                        <span class="count ab">数量</span>

                        <div class="bottom_arrow select_count">
                          <select name="buy_count" id="" class="c5a rb" v-on:change="updateCart()" v-model="cartItem.countItem[0].count">
                            <option v-for="n of cartItem.maxCount + 1" :value="n - 1" :key="n - 1">{{ n - 1 }}</option>
                          </select>
                        </div>

                      </div>
                    </div>
                    <div v-if="cartItem.countItem[1].month != 0" class="month_item" :class="{no_month: cartItem.countItem[1].month == 0}">
                      <p class="month before_border ab" v-if="cartItem.countItem[1].month != 0"><span class="month_number rb">{{ cartItem.countItem[1].month }}</span>月</p>
                      <p class="month" style="border-bottom: none;" v-else></p>
                      <div class="count_wrap">
                        <span class="count ab">数量</span>
                        <div class="bottom_arrow select_count">
                          <select name="buy_count" id="" class="c5a rb" v-on:change="updateCart()" v-model="cartItem.countItem[1].count">
                            <option v-for="n of cartItem.maxCount + 1" :value="n - 1" :key="n - 1">{{ n - 1 }}</option>
                          </select>
                        </div>

                      </div>
                    </div>
                  </div>
                  <!-- <pre>{{this.editBCList}}</pre> -->
                  <div v-if="cartItem.selectChildFund" class="kodomo_wrap">
                    <input class="kodomo_check" type="checkbox" v-bind:id="'kodomo' + n" name="checkbox01" v-on:change="updateCart()" v-model="cartItems[n].child" v-bind:checked="cartItem.child">
                    <label v-bind:for="'kodomo' + n" class="checkbox01 ab">こども基金を支援する</label>
                  </div>
                  <div class="select_price" v-bind:class="{ mt20: !cartItem.selectChildFund }">
                    <p class="item_price rm" v-model="cartItem.price"><span class="yen ab">￥</span>{{ cartItem.price.toLocaleString() }}</p>
                    <p v-if="cartItem.point != 0" class="item_point rm" v-model="cartItem.point"><span class="point_text ab">ポイント：</span>{{ cartItem.point.toLocaleString() }}<span class="point ab">pt</span></p>
                  </div>
                </div>
              </div>

              <div class="select_item select_sum">
                <div class="select_price">
                  <p class="item_price rm" v-model="this.bcTotalPrice"><span class="subtotal ab">小計：</span><span class="yen ab">￥</span>{{ this.bcTotalPrice .toLocaleString()}}</p>
                  <p class="item_point rm"><span class="point_text ab">このご注文での獲得ポイント：</span>{{ this.bcTotalPoint.toLocaleString() }}<span class="point ab">pt</span></p>
                </div>
              </div>

              <div class="cart_btn_wrap bottom">
                <button class="btn_blue" @click="onClickNextPage()">次へ</button>
              </div>


            </div>

            <div class="cart_none none ab pt16 pl16 pr16" v-else>カートに商品はありません</div>
          </div>

          <div class="bc_other" v-else-if="this.cartTab === '2'">
            <div class="" v-if="this.editBCList.length != 0">
              <div class="other_bc" v-model="editBCList" v-for="(bc, n) in editBCList" :key="n">
                <p class="bc_number rb">BC：{{ bc.bc }}</p>
                <div class="other_number--detail">
                  <p class="other_bc--price rm"><span class="yen ab">￥</span>{{ bc.bcPrice.toLocaleString() }}</p>
                  <p class="other_bc--point rm"><span class="point ab">ポイント：</span>{{ bc.bcPoint.toLocaleString() }}<span class="pt ab">pt</span></p>
                  <button class="edit other_edit btn_yellow btn_mini" v-on:click="changeBC(bc.bc)">編集</button>
                </div>
              </div>

              <div class="cart_btn_wrap bottom">
                <button class="btn_blue" @click="onClickNextPage()">次へ</button>
              </div>
            </div>

            <div class="none ab pt16 pl16 pr16" v-else>BCの商品はありません</div>

          </div>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
import scrollPosition from '@/model/scrollPosition';
import Config from '@/config/config';
import { mapGetters } from 'vuex';

export default {
  props: ['open', 'addItem', 'cartChange'],
  data () {
    return {
      cart: false,
      cartTab: '1',
      cartItems: [],
      bcTotalPrice: 0,
      bcTotalPoint: 0,
      allBcPrice: 0,
      allBcPoint: 0,
      editBCList: [],
      change: false,
    };
  },
  methods: {
    onClickNextPage() {
      this.$refs.modal__content.scrollTop = 0;
      this.setPurchaseCartBC(this.purchaseNowBC);
      // console.log(this.purchaseNowBC);
      this.init(this.purchaseCartBC);
      this.cartTab = '1';
      scrollPosition.close();
      this.$emit('checkCart');
    },
    close () {
      this.$refs.modal__content.scrollTop = 0;
      this.setPurchaseCartBC(this.purchaseNowBC);
      // console.log(this.purchaseNowBC);
      this.init(this.purchaseCartBC);
      this.cartTab = '1';
      scrollPosition.close();
      this.$emit('close', false);
    },
    imageError(e) {
      e.target.src = e.target.dataset.noimage;
    },
    updateCart () {
      console.log('updateCart');
      localStorage.setItem(this.purchaseCartBC, JSON.stringify(this.cartItems)); // 個数を更新
      this.cartItems.splice(0, this.cartItems.length);
      let bcItems = JSON.parse(localStorage.getItem(this.purchaseCartBC));
      if (bcItems != null) {
        for (var i = 0; i < bcItems.length; i++) {
          let totalPrice = (bcItems[i].itemPrice * bcItems[i].countItem[0].count) + (bcItems[i].itemPrice * bcItems[i].countItem[1].count);
          let totalPoint = (bcItems[i].itemPoint * bcItems[i].countItem[0].count) + (bcItems[i].itemPoint * bcItems[i].countItem[1].count);

          if (bcItems[i].child) {
            totalPrice = totalPrice + (100 * bcItems[i].countItem[0].count) + (100 * bcItems[i].countItem[1].count);
          }

          let data = {
            item: {
              image: bcItems[i].item.image,
              title: bcItems[i].item.title,
            },
            countItem: [
              { year: bcItems[i].countItem[0].year, month: bcItems[i].countItem[0].month, count: bcItems[i].countItem[0].count },
              { year: bcItems[i].countItem[1].year, month: bcItems[i].countItem[1].month, count: bcItems[i].countItem[1].count }
            ],
            child: bcItems[i].child,
            selectChildFund: bcItems[i].selectChildFund,
            itemPrice: bcItems[i].itemPrice,
            itemPoint: bcItems[i].itemPoint,
            price: totalPrice,
            point: totalPoint,
            genreId: bcItems[i].genreId,
            maxCount: bcItems[i].maxCount,
            productId: bcItems[i].productId
          };

          if(bcItems[i].countItem[0].count == 0 && bcItems[i].countItem[1].count == 0) {
            console.log('どちらも0です');
            console.log(bcItems[i].productId);
            this.$emit('deleteProductId', bcItems[i].productId);
            this.$store.commit('subtractCartCount', 1);
          } else {
            console.log('ok');
            this.cartItems.push(data);
          }

        }
        // 金額、ポイントを更新
        localStorage.setItem(this.purchaseCartBC, JSON.stringify(this.cartItems));
        this.init(this.purchaseCartBC);
      }
    },
    deleteItem (n) {
      this.$emit('deleteProductId', this.cartItems[n].productId);
      this.cartItems.splice(n, 1);
      localStorage.setItem(this.purchaseCartBC, JSON.stringify(this.cartItems));
      this.$store.commit('subtractCartCount', 1);
      // 料金、ポイントを変更するためにカートの要素をもう一度作り直す
      this.init(this.purchaseCartBC);
    },
    calcAllBC() {
      let allBCs = JSON.parse(localStorage.getItem('selectBC'));
      let bcItems = '';
      this.allBcPrice = 0;
      this.allBcPoint = 0;
      if (allBCs != null) {
        for (var i = 0; i < allBCs.length; i++) {
          bcItems = JSON.parse(localStorage.getItem(allBCs[i]));
          if (bcItems != null) {
            for (var a = 0; a < bcItems.length; a++) {
              this.allBcPrice = this.allBcPrice + bcItems[a].price;
              this.allBcPoint = this.allBcPoint + bcItems[a].point;
            }
          }
        }
      }
    },
    createData (bc) {
      this.cartItems.splice(0, this.cartItems.length);
      let bcItems = JSON.parse(localStorage.getItem(bc));
      console.log('methods createData bcItems');
      // console.log(bcItems);
      let totalPrice = 0;
      let totalPoint = 0;
      if (bcItems != null) {
        for (var i = 0; i < bcItems.length; i++) {
          this.cartItems.push(bcItems[i]);
          totalPrice = totalPrice + bcItems[i].price;
          totalPoint = totalPoint + bcItems[i].point;
        }
        this.bcTotalPrice = totalPrice;
        this.bcTotalPoint = totalPoint;

        // カートの個数を表示する
        this.$emit('cartCount', bcItems.length);
      }

    },
    editBC () {
      if (this.editBCList.length != 0) {
        this.editBCList.splice(0, this.editBCList.length);
      }
      let allBCs = JSON.parse(localStorage.getItem('selectBC'));
      let bcItems = '';
      if (allBCs != null) {
        for (var i = 0; i < allBCs.length; i++) {
          let bcPrice = 0;
          let bcPoint = 0;
          bcItems = JSON.parse(localStorage.getItem(allBCs[i]));
          if (bcItems != null) {
            for (var a = 0; a < bcItems.length; a++) {
              bcPrice = bcPrice + bcItems[a].price;
              bcPoint = bcPoint + bcItems[a].point;
            }
          }
          if (bcPrice > 0) {
            let bcData = {
              bc: allBCs[i],
              bcPrice: bcPrice,
              bcPoint: bcPoint
            };
            this.editBCList.push(bcData);
          }

        }
      }

    },
    setPurchaseCartBC(bc) {
      this.$store.commit('setPurchaseCartBC', bc);
    },
    changeBC (bcNumber) {

      this.setPurchaseCartBC(bcNumber);
      this.init(bcNumber)
      this.cartTab = '1';
    },
    init(bc) {
      this.calcAllBC();
      this.createData(bc);
      this.editBC();
    },
  },
  computed: mapGetters(['purchaseNowBC', 'purchaseCartBC']),
  created() {
    this.setPurchaseCartBC(this.purchaseNowBC);
    this.init(this.purchaseCartBC)
  },
  watch: {
    addItem () {
      this.init(this.purchaseCartBC);
    },
  }
};
</script>

<style lang="css" scoped>
/* カートに商品がない場合 */
.cart_none {
  padding: 15px;
}
/* カート中身 */
.detail_wrap {
  overflow-y: inherit;
  padding-top: 74px;
}

.cart_wrap {
  border-bottom: 1px solid #c9c9c9;
  padding: 16px 16px 10px;
}

.cart_title {
  font-size: 18px;
}

.price_wrap {
  color: #009FA9;
  text-align: right;
}

.price_sum {
  font-size: 28px;
}

.yen {
  font-size: 22px;
}

.cart_point {
  font-size: 18px;
}

.point {
  font-size: 14px;
}

.cart_pt {
  font-size: 14px;
}

.cart_tab input {
  display: none;
}

.cart_tab {
  border-bottom: 1px solid  #aaa;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.cart_tab .tab {
  border: solid #AAAAAA;
  border-width: 1px 1px 0;
  border-radius: 12px 12px 0 0;
  background-color: #f4f4f4;
  color: #A3A3A3;
  font-size: 20px;
  padding: 9px 0 8px 16px;
  width: 49.9%;
}

.cart_tab .tab.isActive {
  background-color: #fff;
  color: #5a5a5a;
}

.other_bc {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 37px 16px 25px;
}
.bc_number {
  font-size: 20px;
}

.other_number--detail {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}
.other_bc--price {
  font-size: 26px;
}
.yen {
  font-size: 20px;
}
.btn_mini {
  margin: 16px 0 0;
}

.select_item {
  border-bottom: 1px solid  #c9c9c9;
  display: flex;
  justify-content: space-between;
  padding: 30px 15px 25px 30px;
}
.image_wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  width: 33%;
}

.month_item {
  display: flex;
  margin-top: 16px;
}



.before_border::before {
  border-left: 4px solid #4FCCD4;
  bottom: 0;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
}

.count_wrap {
  align-items: center;
  display: flex;
  margin-left: 8px;

}

.select_item--title {
  font-size: 12px;
  margin-top: 12px;
}
.btn_delete {
  margin: 21px auto 0;
}

.select_contents {
  width: 59%;
}

.manth_wrap {
  margin-top: 0;
}

.month {
  border-bottom: 1px solid #c9c9c9;
  font-size: 16px;
  letter-spacing: 1px;
  padding-left: 8px;
  position: relative;
  width: 40%;
}

.month::before {
  bottom: 2px;
  left: 0;
  width: 4px;
}

.month_number {
  font-size: 22px;
}

.count_wrap {
  align-items: flex-end;
  width: 60%;
}

.count {
  font-size: 12px;
}

.select_count {
  border-bottom: 1px solid #5a5a5a;
  margin-left: 5px;
  width: 63%;
}
.select_count:after {
  bottom: 6px;
  right: 0;
}
.select_count select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 20px;
  padding-left: 7px;
  width: 100%;
}

.checkbox01 {
  display: flex;
  font-size: 14px;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 5px 0 5px 30px;
}

.checkbox01::before {
  left: 0;
}

.checkbox01::after {
  left: 5px;
}

.select_price {
  align-items: flex-end;
  display: flex;
  flex-direction: column;
}

.item_price {
  font-size: 26px;
}

.yen {
  font-size: 20px;
}

.item_point {
  font-size: 16px;
}

.point_text {
  font-size: 12px;
}

.select_sum {
  display: block;
  margin-top: 0;
  padding: 24px 15px;
}

.select_sum .item_price {
  margin-top: 0;
}

.select_sum .subtotal {
  font-size: 14px;
}

.bg.open {
  top: 0;
}

.detail_wrap {
  max-height: 100%;
}

.buy_text {
  width: 70%;
}
.input_number {
  border: none;
  border-bottom: 1px solid #000;
  display: block;
  font-size: 26px;
  padding-right: 5px;
  text-align: right;
  width: 100%;
}

.no_month {
  justify-content: flex-end;
}
.no_month .month {
  display: none;

}
.no_month .count_wrap {
  margin-left: 0;
  width: 65%;
}
.no_month .count {
  width: 30%;
}
.no_month .select_count {
  margin-right: 0;
  margin-left: 0;
  width: 70%;
}

.cart_btn_wrap {
  border-bottom: 1px solid #c9c9c9;
  padding-bottom: 16px;
}
.cart_btn_wrap.bottom {
  margin-top: 32px;
  border-bottom: none;
  padding-bottom: 0;

}
.modal_item.modal_cart .scroll {
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/Cart.vue